import { BehaviorSubject, Observable } from 'rxjs';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ElementRef, Injectable } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';
import { SupervisorDataByLogin, ViewType } from './supervisor.model';

@Injectable({
	providedIn: 'root'
})
export class SupervisorService {

	private BASE_URL_SUPERVISORS = '/api/v2/dashboards/modules/cxone/supervisorgames';
    private readonly _currentView$ = new BehaviorSubject<ViewType>(ViewType.cardView);
    private readonly _seeMoreContainer$ = new BehaviorSubject<ElementRef | null>(null);
    private readonly _moduleManager$ = new BehaviorSubject<ModuleManager | null>(null);

	constructor(
		private cvApiService: CVApiService,
	) { }

	public async getSupervisorsData(moduleKey: string, loginId: number) {
		try {
            const url = `${this.BASE_URL_SUPERVISORS}/${moduleKey}/loginId/${loginId}?isCXone=true`;
			const response: any = await this.cvApiService.get(url);
			if (response.status_code >= 200 && response.status_code < 300) {
				return response.data;
			} else {
				throw response;
			}
		} catch (error) {
			console.error("Failed getting data for supervisor module");
			throw error;
		}
	}

    /**
     * Sets the current view.
     * @param view - The new view type to set.
     */
    public setCurrentView(view: number): void {
        this._currentView$.next(view);
    }

    /**
     * Gets the current view as an observable.
     * @returns Observable of the current view.
     */
    public getCurrentView(): Observable<number> {
        return this._currentView$.asObservable();
    }

    /**
     * Sets the 'see more' container element.
     * @param container - The ElementRef of the container.
     */
    public setSeeMoreContainer(container: ElementRef): void {
        this._seeMoreContainer$.next(container);
    }

    /**
     * Gets the 'see more' container as an observable.
     * @returns Observable of the container ElementRef.
     */
    public getSeeMoreContainer(): Observable<ElementRef | null> {
        return this._seeMoreContainer$.asObservable();
    }

    /**
     * Sets the module manager instance.
     * @param moduleManager - The module manager instance to set.
     */
    public setModuleManager(moduleManager: ModuleManager): void {
        this._moduleManager$.next(moduleManager);
    }

    /**
     * Gets the module manager as an observable.
     * @returns Observable of the module manager instance.
     */
    public getModuleManager(): Observable<ModuleManager | null> {
        return this._moduleManager$.asObservable();
    }
}
